const { APP_NAME, SHORT_DOMAIN, APP_HOST } = window.ThrowdownsConfig;
const year = (new Date()).getFullYear();

export default {
  key: 'en',
  name: 'English',
  messages: {
    fitToRegistrations: 'Fit to registration counts',
    distributionMenu: 'Distribution',
    customLabelsMenu: 'Custom Labels',
    customLabelsHeader: 'Custom Labels',
    scoreCertificationCustomLabelLabel: 'Score Certification Label',
    scoreCertificationCustomLabelDescription: 'Override the default score certification label of "Certification"',
    scoreCertificationCustomHelpLabel: 'Score Certification Help',
    scoreCertificationCustomHelpDescription: 'Override the default score certification help text of "Check this box if you did not modify the standards for your division (lighter weights, modified movements, etc.)"',
    rxCertifyStatementCustomLabelLabel: 'Rx Certification Statement',
    rxCertifyStatementCustomLabelDescription: 'Override the default Rx certification statment of "I completed the workout according to the written standards for this division."',
    certificationDescriptionCustomLabelLabel: 'Certification Description',
    certificationDescriptionCustomLabelDescription: 'Override the default certification help text of "Leaving this box empty means that you modified the workout in some way. Your scores will appear at the bottom of the leaderboard."',
    defaultCurrency: 'usd',
    email: 'Email',
    ticket: 'Ticket',
    startDescription: 'Start Lane',
    endDescription: 'End Lane',
    eventNameLabel: 'Event Name',
    eventNameDescription: '',
    ticketId: 'Ticket ID',
    lastScan: 'Last Redeemed',
    totalScans: 'Total Redemptions',
    buyTickets: 'Buy Tickets',
    specTickets: 'Spectator Tickets',
    yourTickets: 'Your Tickets',
    print: 'Print',
    buyMoreTickets: 'Buy More Tickets',
    ticketSalesClosedHeader: 'Ticket Sales Closed',
    ticketSalesClosedText: 'Tickets are not currently on sale.',
    loginToBuyTickets: 'In order to buy tickets, you need to ',
    viewTickets: 'View Tickets',
    buyTicketsToday: 'Buy Tickets Today!',
    tickets: 'Tickets',
    ticketsPanelHeading: 'Tickets',
    ticketsAddingItem: 'Adding Ticket',
    ticketsAddItemButton: 'Add Ticket',
    ticketItemName: 'Ticket Name',
    brandUrlLabel: 'Website URL',
    brandUrlDesc: 'If provided, this URL will be linked to the logo image in emails and on public competition pages.',
    marketingSetupUploadLogo: 'Upload Logo',
    marketingSetupPicLogoHelp: `Suggested dimensions: 500x500. (You can pan/zoom/crop after upload). If you provide an image, it will appear on your public competition pages and in any emails sent out by ${APP_NAME}.`,
    sendersNameOnEmailDesc: `The name that will appear as the sender on any automated emails for this competition. Defaults to '${APP_NAME}'.`,
    sendersNameOnEmail: 'Senders Name',
    ticketItemNameDescr: 'The name of the class of ticket you want to sell (e.g. VIP, Regular, Student)',
    ticketDescriptionDescr: 'A brief description of this class of ticket',
    ticketDescriptionName: 'Ticket Description',
    ticketSalesOpen: 'Open Date for Ticket Sales',
    ticketSalesClose: 'Close Date for Ticket Sales',
    ticketingContent: 'Ticketing Content',
    ticketingContentLead: 'This content is displayed at the top of your ticket sales page.',
    fieldTypeChoiceFreeResponseOneLine: 'Free Response - One Line',
    fieldTypeChoiceFreeResponseBox: 'Free Response - Box',
    fieldTypeChoiceMultipleChoicePickOne: 'Multiple Choice - Pick One',
    fieldTypeChoiceMultipleChoicePickOneDropdown: 'Multiple Choice - Pick One (Dropdown)',
    fieldTypeChoiceMultipleChoiceCanSelectMultipleAnswers: 'Multiple Choice - Can Select Multiple Answers',
    pointsTable200Points: '200 Points',
    pointsTable100Points: '100 Points',
    pointsTable50Points: '50 Points',
    pointsTableCustomPoints: 'Custom Points',
    HigherisBetter: 'Higher is Better',
    LowerisBetter: 'Lower is Better',
    tiePolicyTiesStand: 'Ties Stand (Max Points)',
    tiePolicyTiesStandAverage: 'Ties Stand (Average Points)',
    tiePolicyHigherisBetter: 'Higher is Better',
    tiePolicyLowerisBetter: 'Lower is Better',
    scoringPolicyPlacement: 'Placement',
    scoringPolicyMaxPoints: 'Max Points',
    scoringPolicyMinPoints: 'Min Points',
    scoringPolicyPointsTable: 'Points Table',
    pointsTableLabelCustom: 'Custom',
    rank: 'Rank',
    bib: 'Bib',
    leaderboardNameColumnHeader: 'Athlete / Team',
    scorer: 'Scorer',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    dashboard: 'Dashboard',
    manage: 'Manage',
    preview: 'Preview',
    registered: 'Registered',
    submitScores: 'Submit Scores',
    yourCompetitions: 'Your Competitions',
    addCompetition: 'Add Competition',
    duplicate: 'Duplicate',
    setup: 'Setup',
    programming: 'Programming',
    programmingComplete: 'Programming Complete',
    registration: 'Registration',
    registrationComplete: 'Registration Complete',
    payments: 'Payments',
    paymentsComplete: 'Payments Complete',
    published: 'Published',
    publish: 'Publish',
    requested: 'Requested',
    request: 'Request',
    inProgress: 'In Progress',
    login: 'Login',
    location: 'Location',
    getDirections: 'Get Directions',
    date: 'Date',
    description: 'Description',
    addScores: 'Add Scores',
    view: 'View',
    register: 'Register',
    now: 'Now',
    yesUndelete: 'Yes, Undelete',
    undelete: 'Undelete',
    closed: 'Closed',
    leaderboards: 'Leaderboards',
    organizedBy: 'Organized By',
    contactTheOrganizer: 'Contact the Organizer',
    getDrivingDirections: 'Get Driving Directions',
    workout: 'Workout',
    workouts: 'Workouts',
    division: 'Division',
    divisions: 'Divisions',
    shareWithFriends: 'Share With Friends',
    athleteRegistration: 'Registration',
    tryAgain: 'Try Again',
    youreRegistered: 'You\'re Registered',
    edit: 'Edit',
    youAreRegConfirm: `Update your <strong><a href='${APP_HOST}/app/my-account/profile'>Athlete Profile</a></strong>`,
    charges: 'Charges',
    card: 'Card',
    registrationFee: 'Registration Fee',
    appliedCouponCode: 'Applied <code>{code}</code>',
    processingFee: 'Processing Fee',
    charge: 'Charge',
    registerToday: 'Register Today',
    loginToRegister: 'In order to register for a competition, you\'ll need to',
    loginLower: 'login',
    dontHaveAccount: 'Don\'t have an account?',
    createOne: 'Create one',
    inUnderAMinute: 'in under a minute',
    alreadyRecorded: 'You already have scores recorded. No changes to your registration are permitted.',
    calculatingTotal: 'Calculating total',
    discount: 'Discount',
    feeBalance: 'Fee Balance',
    totalCharge: 'Total Charge',
    readAndAccept: `I have read and accepted the ${APP_NAME} waiver.`,
    readAndAcceptCompt: 'I have read and accepted the {competitionTitle} waiver.',
    updateRegistration: 'Update Registration',
    calculateTotal: 'Calculate Total',
    submitting: 'Submitting...',
    allDivisionsAreFull: 'All divisions are full',
    whatDivision: 'What division do you want to register for?',
    leaderboardName: 'Leaderboard Name',
    leaderboardDescription: 'The name you wish to appear on the leaderboard',
    memberFormHeading: 'Team Member {memberIndex} / {registrants}',
    registrantName: 'Registrant Name',
    registrantFirstName: 'First Name',
    registrantLastName: 'Last Name',
    registrantFirstNameDescription: 'Athlete first name',
    registrantLastNameDescription: 'Athlete last name',
    registratioCustomNamesCheckboxMessage: 'Restrict custom leaderboard names for individual divisions',
    registrationCustomNamesDescr: 'By default, athletes in individual divisions are not offered a field to input a custom leaderboard name. Instead, their displayed leaderboard name is their first and last name. Unchecking this option will allow athletes to enter their leaderboard name as any value. This setting does not affect team divisions.',
    registratDescription: 'Athlete name',
    registrantEmail: ' Email Address',
    registrantEmailDescription: 'Athlete email address',
    coupon: 'Coupon',
    couponIsValid: 'Coupon is valid',
    couponIsInValid: 'Coupon is invalid',
    enterCoupon: 'Enter your coupon code',
    helpfulLinks: 'Helpful Links',
    privacyTerms: 'Privacy & Terms',
    throwdownsBlog: `${APP_NAME} Blog`,
    copyright: `© 2014-${year} - ${SHORT_DOMAIN} - All Rights Reserved`,
    rotateLeaderboards: 'Cycle Leaderboards',
    filterAthletes: 'Filter Athletes',
    athleteName: 'Athlete Name',
    noLeaderboard: 'No leaderboard has been published yet',
    loading: 'Loading...',
    points: 'Points',
    switchDivisions: 'Switch Divisions',
    needPassword: 'You need a password set to be able to log back in',
    setPassword: 'Set Password',
    title: 'Title',
    startDate: 'Start Date',
    endDate: 'End Date',
    venueName: 'Venue Name',
    creatingCompetition: 'Creating Competition',
    beginSetup: 'Begin Setup',
    finishSetupComp: 'Finish & Setup Competition',
    continue: 'Continue',
    setupWelcomeIntro: `We're thrilled you're interested in ${APP_NAME}`,
    setupWelcomeMain: 'Let\'s begin setting up your first competition. Just answer a few simple questions to get started!',
    setupName: 'What is the name of your competition?',
    myCompetitionName: 'My Competition Name',
    setupKindOnline: 'Is <span class="comp-name">{compName}</span> an online competition?',
    setupKindOnlineDescr: 'An online competition is where your athletes compete and submit scores online from anywhere in the world rather than having judges record scores onsite.',
    goBack: 'Go Back',
    whereCompLoc: 'Where will <span class=\'comp-name\'>{compName}</span> be held?',
    venueAddress: 'Venue Address',
    setupCompDate: 'When will <span class="comp-name">{compName}</span> take place?',
    timeZoneDescr: 'The timezone for your published competition times',
    timeZoneDescrLabel: 'Timezone',
    start: 'Start',
    end: 'End',
    setupLastStep: 'Last step! Just one more thing!',
    setupUploadCoverPhoto: 'Upload a cover photo for <span class="comp-name">{compName}</span>',
    suggestedDim: 'Suggested dimensions: {width}x{height}',
    dragOrClickPhoto: 'Drag Photo or Click to Upload',
    finishCropping: 'Finish Cropping',
    imageWarning: 'Your image is less than recommended dimensions and will likely be blurry. We recommend at least {recommendedWidth}x{recommendedHeight} and your image is {width}x{height}.',
    selectDate: 'Select Date',
    setupCongrats: 'Congratulations! You\'ve successfully setup a competition!',
    setupQuickSteps: 'Your landing page is ready! There are just a few quick steps to get your competition launched...',
    launch: 'Launch',
    marketingSetupTitlePage: 'The title of your page',
    marketingSetupCompName: 'Competition Name',
    marketingSetupCompEmail: 'Reply To Email Address',
    marketingSetupCompEmailDesc: `The primary contact email address for this competition. This email will appear on your public competition pages. Replies to any ${APP_NAME} automated emails for this competition will also be sent to this address.`,
    marketingSetupShortlinkDescr: 'The slug in your competition URL',
    marketingSetupShortlinkTitle: 'Shortlink ID',
    marketingSetupUpload: 'Upload a cover photo',
    marketingSetupMobileUpload: 'Upload a cover photo for mobile (optional)',
    marketingSetupPicHelp: 'Suggested dimensions: {width}x{height}. (You can pan/zoom/crop after upload)',
    marketingSetupOnlineDescr: 'Is this an online competition?',
    marketingSetupOnlineTitle: 'Online Competition',
    invalidDate: 'It is not valid to have an end date/time prior to the start.',
    programmingWelcome: 'Let\'s configure the programming for {compName}!',
    programmingWelcome2: 'We will go over your workouts, divisions, and scoring policies during this setup process.',
    programmmingDiv: 'What divisions will you be featuring?',
    programmmingEx: 'We\'ve added a few examples to get you started. You may drag & drop each division to reorder its position in the list.',
    addDivision: 'Add Division',
    dragDropDivision: 'Drag & Drop divisions to change their order.',
    addDivisionGroup: 'Add Division Group',
    dragDropDivisionGroup: 'Drag & Drop division groups to change their order.',
    teamSize: 'Team Size',
    teamSizeDescr: 'Enter the total number of team members required to register for this division. Leave at 1 if this is a solo/individual registration.',
    maxRegistrations: 'Max Registrations',
    maxRegistrationsDescr: 'Enter the maximum amount of registrations permitted for this division.',
    typeOfDivision: 'Type of Division',
    typeOfDivisionDescr: 'Select the type of users who will be registering for this division. Volunteer divisions will appear at registration, but will not have a scoring table or leaderboard.',
    athlete: 'Athlete',
    volunteer: 'Volunteer',
    spectator: 'Spectator',
    nameOfDivision: 'Enter the name of this division.',
    divisionName: 'Division Name',
    nameOfDivisionGroup: 'The name of the group',
    divisionGroupName: 'Group Name',
    loadingDivisions: 'Loading Divisions...',
    saving: 'Saving...',
    save: 'Save',
    delete: 'Delete',
    deleteAreYouSure: 'Are you sure you would like to delete?',
    deleteFieldItemAreYouSure: 'Are you sure you would like to delete this custom field? Any data collected by this question will be permanently lost.',
    deleting: 'Deleting...',
    programmingWorkouts: 'What workouts will you be featuring?',
    programmingExamples: 'We\'ve added a few examples to get you started. You may drag & drop each workout to reorder its position in the list.',
    addWorkout: 'Add Workout',
    dragDropWorkouts: 'Drag & Drop workouts to change their order.',
    workoutNameDescr: 'The name of the workout',
    workoutName: 'Workout Name',
    loadingWorkouts: 'Loading Workouts...',
    scoringPoliciesUsing: 'What type of scoring policies will you be using?',
    scoringLead: 'These settings will determine how workouts are scored and will be used in calculating athlete placement on leaderboards.',
    dirtyChanges: 'You have unsaved changes. Press Continue save your changes.',
    scoringType: 'Scoring Type',
    scoringTypeDescr: 'Select the leaderboard scoring policy to apply.',
    scoringOrder: 'Scoring Order',
    scoringOrderDescr: 'Select the order scores should be ranked on leaderboard',
    tieBreakerPolicy: 'Tie Breaker Policy',
    tieBreakerPolicyDescr: 'Select how tie breakers should resolve on leaderboard',
    pointsTablePolicy: 'Points Table Policy',
    pointsTablePolicyDescr: 'Select the number of points that will be used to calculate athlete placement (200, 100, and 50 points table supports up to 40 athletes).',
    goYou: 'Go you!',
    programmingConfigured: 'Programming for <span class="comp-name">{compName}</span> has been successfully configured!',
    marketingContentTitle: 'Landing Page Content',
    marketingTimeVenueDescr: 'The name of your venue',
    marketingTimeVenueTitle: 'Venue Name',
    marketingTimeAddressDescr: 'Start typing your street address',
    marketingTimeAddressTitle: 'Venue Address',
    marketingTimeZoneDescr: 'The timezone for your published competition times',
    marketingTimeZoneTitle: 'Timezone',
    marketingOnlineHeader: 'Online Scoring',
    marketingOnlineSubHeader: 'Control how score submissions are handled for each workout in this competition.',
    marketingOnlineWorkouts: 'Workouts',
    marketingOnlineInstr: 'Instructions for Score Submission',
    marketingOnlineVideoTitle: 'Video Link',
    marketingOnlineVideoDescr: 'Is the athlete required to submit a link to a video of their workout?',
    marketingOnlineImageTitle: 'Image',
    marketingOnlineImageDescr: 'Is the athlete required to submit an image their workout?',
    marketingOnlineJudgeTitle: 'Judge',
    marketingOnlineJudgeDescr: 'Is the athlete required to submit the name of the person who judged their workout?',
    marketingOnlineScoreOpens: 'Scoring Opens',
    marketingOnlineScoreCloses: 'Scoring Closes',
    optional: 'Optional',
    required: 'Required (will be required to supply in order to submit score)',
    notOption: 'Not an Option (won\'t display input)',
    registrationConfig: 'Let\'s configure the registration for {compName}!',
    registrationSecondary: 'We will go over your divisions, dates, fees and content during this setup process.',
    finish: 'Finish',
    registrationWhen: 'When should registration start and end?',
    registrationAvail: 'Select when registration for your event will be available.',
    registrationOpens: 'Registration Opens',
    registrationCloses: 'Registration Closes',
    registrationCost: 'How much does it cost to register?',
    registrationFeesSet: 'Registration fees can be set uniquely by division.',
    preferredCurrency: 'Preferred Currency',
    preferredCurrencyHelp: 'Your preferred currency for transactions. **These currencies do not support the use of AMEX.',
    divisionRegistrationFees: 'Division Registration Fees',
    registrationContentMain: 'Anything to say while athletes register?',
    registrationContentSpecial: 'If you wish to have any special instructions appear at the top of your registration form such as refund policies or other important things for athletes to know ahead of purchasing tickets, add it here. Otherwise, you can leave this blank.',
    registrationConfigured: 'Registration for <span class="comp-name">{compName}</span> has been successfully configured!',
    accountHeader: 'Your Account',
    accountSettings: 'Account Settings',
    languagePreference: 'Language Preference',
    accountSubscription: 'Subscription',
    accountEmailAddress: 'Email Address',
    accountPassword: 'Password',
    accountConfirmPassword: 'Confirm Password',
    profileSettings: 'Profile Settings',
    profileUsername: 'Username',
    profileUsernamePlaceholder: 'Enter a username',
    profileUsernameCanBeSetOnce: 'Your username can only be set once and cannot be changed.',
    profileSetUsername: 'Please set your username in order to edit your profile details.',
    profileGender: 'Gender',
    profileName: 'Name',
    profileFirstNamePlaceholder: 'First Name',
    profileLastNamePlaceholder: 'Last Name',
    profileDisplayName: 'Display Name',
    profileDisplayNamePlaceholder: 'Preferred display name on leaderboards',
    profileBio: 'About Me',
    profileBioPlaceholder:
    `This is where you can submit additional details about yourself as an athlete! Many of our users include topics such as:

      - Workout Routine
      - Diet
      - Competition Highlights
      - Hobbies

And more! You can always come back and edit your bio at anytime if you aren't sure what to say right now.`,
    profileAssociationsHeader: 'Associations',
    profileCountry: 'Country',
    profileAffiliate: 'Affiliate',
    profileAffiliatePlaceholder: 'Where you train',
    profileSocialHeader: 'Social Profiles',
    profileTwitterHandlePlaceholder: 'Your Twitter handle',
    profileFacebookUsernamePlaceholder: 'Your Facebook username',
    profileInstagramHandlePlaceholder: 'Your Instagram handle',
    profileMustSetUsernameToSave: 'You must set your username to save your profile.',
    profilePublic: 'Profile is public.',
    profilePrivate: 'Profile is private.',
    profilePublicLink: 'Profile Link',
    profilePublicLinkDescr: 'A link to share your public profile.',
    athleteAthleteBio: 'Athlete Bio',
    athleteUsernameNotFound: 'It seems that profile does not exist.',
    athleteNoBio: 'This athlete has not provided any bio information yet.',
    unspecified: 'Unspecified',
    onlineScoring: 'Online Scoring',
    content: 'Content',
    timeAndPlace: 'Time & Place',
    help: 'Help',
    coupons: 'Coupons',
    customWaiver: 'Custom Waiver',
    customFields: 'Custom Fields',
    scoringPolicies: 'Scoring Policies',
    marketing: 'Marketing',
    guidedSetup: 'Guided Setup',
    retail: 'Retail',
    fees: 'Fees',
    dates: 'Dates',
    deposits: 'Deposits',
    advanced: 'Advanced',
    registrants: 'Registrants',
    scoreEntry: 'Score Entry',
    management: 'Management',
    support: 'Support',
    dataEntryLinks: 'Data Entry Links',
    leaderboardSettings: 'Leaderboard Settings',
    noContent: 'No Content',
    editContent: 'Edit Content',
    registrationContent: 'Registration Content',
    registrationLead: 'If you wish to have any special instructions appear at the top of your registration form such as refund policies or other important things for athletes to know ahead of purchasing tickets, add it here. Otherwise, you can leave this blank.',
    connectToAStripeAccount: 'Connect to a Stripe Account',
    connectToNewStripeAccount: 'Connect to New Stripe Account',
    stripeLead: 'We partner with Stripe, the industry\'s best payment processor, so that you always have complete control of your registration funds.',
    stripeNotConnected: 'You haven\'t connected to a Stripe Account yet',
    letsDoThatNow: 'Let\'s do that now',
    yourStripeAccounts: 'Your Stripe Accounts',
    yourStripeAccountsDescr: 'Which of these Stripe accounts should receive deposits for this competition?',
    depositsNeedHelp: 'Need help with deposits? Contact us at',
    youWillReceive: 'You will receive payments on your <strong>{acctName}</strong> Stripe account.',
    stripeOptOut: 'Since you have opted to not use Stripe, we will collect your registration fees for you. Funds will be released 45 days after your competition is over and after assessing a $150 processing fee.',
    registrantDivisionTitle: '{divTitle} Registrants',
    registrantsExport: 'Prepare Export',
    registrantsExportPrep: 'Preparing...',
    registrantsExportView: 'View Export',
    registrantsLeaderboardName: 'Leaderboard Name',
    registrantsTeamMembers: 'Team Members',
    registrantsAthleteName: 'Athlete Name',
    registrantsDate: 'Registered At',
    registrantsCharges: 'Charges',
    registrantsChangeDivision: 'Change Division',
    registrantsAddDivision: 'Register for Additional Division',
    addCoupon: 'Add Coupon',
    loadingCoupons: 'Loading Coupons...',
    registrationWaiverContent: 'Registration Waiver Content',
    registrationWaiverContentLead: 'This default waiver should work well, but if you have you own that you\'d like registering athletes to agree to, then just replace it.',
    addField: 'Add Field',
    customRegistrationFields: 'Custom Registration Fields',
    loadingRegistrationFields: 'Loading Registration Fields',
    label: 'Label',
    labelDescr: 'The label for your field.',
    helpText: 'The help text for your field. This text is \'help text\'',
    helpTextLabel: 'Help Text',
    requiredField: 'Require this field to be filled out during registration',
    requiredFieldLabel: 'Required',
    team: 'Team',
    teamField: 'Team Question',
    teamFieldLabel: 'This question will only be asked once per registration',
    fieldChoices: 'Choices for this field separated by commas',
    fieldChoicesLabel: 'Field Choices',
    fieldPreview: 'Field Preview',
    couponCode: 'Coupon Code',
    percentageOff: 'Percentage Off',
    amountOff: 'Amount Off',
    numberAvailable: 'Number Available',
    expiration: 'Expiration',
    add: 'Add',
    editCoupon: 'Edit Coupon',
    scoringLink: 'Scoring Link',
    shareThisLink: 'Share this private & secure link with staff for help on scoring',
    shareThisTicketLink: 'Share this private & secure link with staff for help on managing tickets',
    scoring: 'Scoring',
    previewLeaderboard: 'Preview Leaderboard',
    publishedLeaderboard: 'Published Leaderboard',
    refreshing: 'Refreshing',
    enterScoresStatement: 'Enter some scores on the Scoring tab to generate a preview on this tab.',
    publishedLeaderboardLink: 'This is the published leaderboard available at',
    noLeaderboardPublishedStatement: 'You haven\'t published a leaderboard for this division yet. Enter some scores in the Scoring tab and then publish a leaderboard from within the Preview Leaderboard tab.',
    youMadeChangesStatement: 'You\'ve made changes to the scoring. Preview the leaderboard and publish to make live.',
    noScoresDivision: 'There are no scores entered for this division. Add new scores below.',
    name: 'Name',
    addNew: 'Add New',
    score: 'Score',
    tieBreaker: 'Tie Breaker',
    review: 'Review',
    yourScores: 'Your Scores',
    scoresFor: 'Scores for',
    mustAuth: 'You must auth to record your scores',
    instructions: 'Instructions',
    scaled: 'Scaled',
    video: 'Video',
    withdraw: 'Withdraw',
    scoringClosed: 'Scoring Closed',
    withdrawing: 'Withdrawing...',
    scoringIsOpenFrom: 'Scoring is open from',
    addScore: 'Add Score',
    scoringIsClosed: 'Scoring is closed',
    window: 'window',
    scoreDescr: 'What was your score?',
    timeScoreDescr: 'Enter the time it took to complete the entire workout.',
    repScoreDescr: 'Enter the number of reps you were able to complete within the time cap.',
    tieBreakDescr: 'What was your tie breaker?',
    certification: 'Certification',
    rx: 'Rx',
    rxCertifyStatement: 'I completed the workout according to the written standards for this division.',
    scaledCertifyStatement: 'I understand my scores will rank below athletes who followed the standards in this division.',
    selectRxStatement: 'Select Rx if you completed the workout by the standards provided <strong>for your division</strong>. Otherwise, select Scaled to indicate that you scaled the workout beyond the standards <strong>for your division</strong>.',
    certificationHelp: 'Check this box if you did not modify the standards for your division (lighter weights, modified movements, etc.)',
    certificationDescription: 'Leaving this box empty means that you modified the workout in some way. Your scores will appear at the bottom of the leaderboard.',
    videoLink: 'Video Link',
    videoLinkDescr: 'Link to a YouTube or other hosted video of your workout',
    imageLink: 'Image',
    imageLinkDescr: 'Upload an image to be used for score verification',
    judge: 'Judge',
    judgeDesc: 'The name of the person that observed your workout',
    comments: 'Comments',
    expired: 'Expired',
    expiresOn: 'Expires on ',
    extend: 'Extend',
    expire: 'Expire',
    activate: 'Activate',
    deactivate: 'Deactivate',
    active: 'Active',
    inactive: 'Inactive',
    externalScoreThanks: 'Thanks for helping score!',
    hangTight: 'Hang tight...',
    exitWithoutSavingSure: 'Are you sure you want to exit without saving?',
    continueEditing: 'Continue Editing',
    exitWithoutSaving: 'Exit Without Saving',
    finalReviewStatement: 'Your competition is under going final review prior to going live!',
    dashboardSummary: 'A summary of how your competition is going.',
    summary: 'Summary',
    revenue: 'Revenue',
    views: 'Views',
    registrations: 'Registrations',
    outOf: 'out of',
    divisionCapacity: 'Division Capacity',
    by: 'by',
    cumulativeTotalRevenue: 'Cumulative Total Revenue',
    performance: 'Performance',
    regAndTrafficStatement: 'Registrations and traffic to your competition landing page over time.',
    scoreSubmissionHeader: 'Athlete Score Submission',
    athleteAlreadyExists: 'Athlete already entered',
    workoutSubmitScore: 'Submit Score',
    only: 'only',
    spots: 'spot | spots',
    remaining: 'remaining',
    stripeDeclined: 'Your card was declined.',
    stripeInsufficient: 'Your card has insufficient funds.',
    twitterMessage: '{compName} looks great. Check this out:\n\n{href}',
    shareEmailSubject: 'Check out {compName}',
    shareEmailMessage: '{compName} looks great. Check this out:\n\n{href}',
    deleteCouponMessage: 'Are you are you sure you wish to delete the <strong>{code}</strong> coupon?',
    unsupportedBrowHead: 'Unsupported Browser',
    unsupportedBrowButton: 'OK',
    unsupportedBrowDescr: 'It looks like you\'re using an older, unsupported browser. You may run into difficulties using the app. Please upgrade to ensure you get the best experience.',
    networkErrorHead: 'Network Error',
    networkErrorButton: 'Try Again',
    networkErrorDescr: 'Your network connection was lost.',
    clipboardCopy: 'Copied!',
    waiverClose:'Close Waiver',
    waiverShow:'Show Waiver',
    couponDiscount:'{discount}% off',
    failedRegistration:'There was a problem',
    competitionFullHeader: 'Competition is Full',
    divisionsFullDescr: 'All divisions have sold out.  Please contact the organizer to inquire about a waitlist.',
    invitationInviteesCount: 'Invitee(s)',
    registrationRequiredFieldsWarning: 'Please fill out all the required fields.',

    subtotal: 'Subtotal',
    regCardEndingMessage: 'You are performing this transaction on a card ending with',
    merchandise: 'Merchandise',
    orderMerchItem: 'Item',
    orderMerchPrice: 'Price',
    orderMerchQty: 'Qty',
    orderMerchSoldOut: 'Sold Out',
    orderMerchCouponDis: 'Coupon Discount',
    orderMerchSubtotalDis: 'Discounted Subtotal',
    orderMerchNow: 'Order Now',
    merchHeader: 'Retail Items',
    merchAddItem: 'Add a Sale Item',
    merchQty: 'Initial Quantity',
    merchQtyDescr: 'How many of these do you have available for sale?',
    merchExchangeable: 'Exchangeable',
    merchExchangeableDescr: 'Is this item something that is exchangeable for a different item?',
    merchItemName: 'Item Name',
    merchItemNameDescr: 'The name of the item for sale',
    addItemDescrHeader: 'Item Description',
    addItemDescrDescr: 'A short description of your item',
    merchImageUpload: 'Upload an image for the item',
    merchImageHelp: 'Suggested dimensions: {width}x{height}. (You can pan/zoom/crop after upload)',
    merchLoading: 'Loading Items for Sale...',
    orderMerchButton: 'Order Merchandise',
    editDetailsButton: 'Edit Details',
    releaseTime: 'Release Time',
    releaseTimeDescription: 'Select the time you would like your workout details to be revealed to athletes. Workouts before the \'Release Time\' will have a placeholder of \'TBA Workout\'.',
    invalidVideo: 'Invalid Video',
    athleteComment: 'Athlete Comment',
    exportAsCSV: 'Export as CSV',
    exportAsPDF: 'Export as PDF',
    heatScoringOptOut: 'Heat Scoring Opt-Out',
    scoringImportAthletes: 'Import',
    scoringImportAthletesDescr: 'Paste in the names of your athletes to add them to the scoring table.',
    importingAthletes: 'Importing...',
    bibNumbers: 'Bib Number',
    enterBibNumber: 'Enter Bib Number',
    toggleBibs: 'Toggle Bibs',
    merchReceiptQty: 'Quantity',
    merchPurchasedItems: 'Purchased Items',
    registrationClosedBody: 'Registration Closed',
    registrationClosedBodyDescr: 'Registration is now closed.',
    noWorkoutFound: 'No Workout Found',
    noWorkoutFoundDescr: 'This workout does not exist.',
    noDivisionFound: 'No Division Found',
    noDivisionFoundDescr: 'This division does not exist.',

    competitionCard: {
      duplicateAlert: 'Are you sure you want to duplicate this competition?'
    },
    divisionTeamReqMessage: '{teamSize}-member teams required',
    throwdownsWaiver: `<h4>Assumption of Risk and Agreement Participation Release of Liability</h4>
                <p>In consideration of being allowed to participate in any way in the program, related events and activities, I acknowledge and agree that:</p>
                <ul>
                <li>The risk of injury from the activities involved in this program are significant, including the potential for permanent paralysis and death.</li>
                <li>I knowingly and freely assume all such risks, both known and unknown, even if rising from the negligence of the releasees or others, and assume full responsibility for my participation.</li>
                <li>I willingly agree to comply with the terms and conditions for participation. If I observe any unusual significant hazard during my presence, or participation, I will remove myself from participation and bring such to the attention of the nearest official immediately.</li>
                <li>I, for myself, and on behalf of my heirs, executors, administrators, personal representatives, successors and assigns, waive and release any and all rights, claims and courses of action I have or may have against the organizers or anyone associated with the entity, it’s Primary Sponsor and it’s affiliates, their agents, employees, officers, directors, successors and assigns, the event management company, the City, The Parks Districts, and any and all sponsors, their representatives and successors, that may arise as a result of my participation in the event and any pre-and post-event activities.</li>
                <li>I attest and verify that I am physically fit and have sufficiently trained for the completion of this program, related event and/or related activities, and a licensed medical doctor has verified my physical condition.</li>
                <li>Further, I hereby grant full permission to any and all of the foregoing to use any photographs, motion pictures, recordings, or any other record of this event for any legitimate purpose including commercial advertising.</li>
                <li>I verify that I am either 18+ years of age or that I have parental consent to participate in strenuous physical exercise.</li>
                </ul>`,

    setupProgramming: '@:setup @:programming',
    setupRegistration: '@:setup @:registration',
    setupPayments: '@:setup @:payments',
    publishRequested: '@:publish @:requested',
    requestPublish: '@:request @:publish',
    viewRegistration: '@:view @:registration',
    registerNow: '@:register @:now',
    buyTicketsHeader: 'Buy Tickets Today',
    registrationClosed: '@:registration @:closed',
    registrationSuccess: 'Registration successful',
    noWorkoutForThisDivision: 'No workouts have been announced yet.',
    noDivisionsForThisWorkout: 'No divisions for this workout have been created yet.',
    yesDelete: '@:yes, @:delete',

    heatScheduling: 'Scheduling',
    heatsSubMenu: 'Manage Heats',
    heatsLocations: 'Locations',
    heatsWorkoutLocations: 'Workout Locations',
    heatsSchedules: 'Schedules',
    heatsSegments: 'Segments',
    athleteAssignmentsLabel: 'Athletes',
    heatManageAssignments: 'Heat and Lane Assignments',
    heatsManageTimes: 'Heat Times',
    schedule: 'Schedule',
    heatsJudges: 'Judges',
    loadingLocations: 'Loading Locations...',
    addLocation: 'Add Location',
    heatsWorkoutParams: 'Workout Heat Parameters',
    workoutDurationDesc: 'The amount of time (minutes) allotted for an athlete to complete this workout',
    workoutDurationLabel: 'Duration',
    configStartEnd: 'Time',
    actualStartEnd: 'Time',
    heatConfigurationDiffers: 'Heat Configuration',
    heatConfigurationDiffersDesc: 'Heat configuration does not match event configuration.',
    workoutTransitionTimeDesc:' The amount of time (minutes) allotted for transition between athletes',
    workoutTransitionTimeLabel: 'Transition Time',
    workoutNumberOfLanesDesc:'The number of lanes available for this workout',
    workoutNumberOfLanesLabel: 'Number of Lanes',
    laneAssignmentStrategyLabel: 'Lane Assignments',
    laneAssignmentStrategyDesc: 'How lanes will be assigned based on athlete rankings',
    workoutTimeCapDescr: 'Time cap for this workout is {timeCap}',
    workoutTimeCapAllRepsCompleted: '<strong>All {totalRepsInWorkout} reps</strong> were completed within the time cap.',
    workoutTimeCapFewerRepsCompleted: '<strong>Fewer than {totalRepsInWorkout} reps</strong> were completed within the time cap.',
    heatsLaneEmpty: '{laneLabel} Empty',
    heatsJudgeLaneEmpty: 'Lane is empty',
    heatsLane: 'Lane {athleteIndex}',
    heatsPending: 'Lane Empty',
    calculating: 'Calculating...',
    publishing: 'Publishing...',
    heatsStartEnd: 'Start and End Times',
    heatsStartEndDescr: 'The desired start and end time for this day\'s schedule',
    heatsTransTime: 'Transition Time',
    heatsTransTimeDescr: 'The transition time between the completion of one workout/division and the start of the next. Increments by 5 minutes.',
    lane: 'Lane',
    backToTop: 'Back To Top',
    back: 'Back',
    next: 'Next',
    empty: 'Empty',
    printCancel: 'Cancel Print',
    heatsNoPlans: 'Nothing planned',
    heatsStageWorkouts: 'Workouts for this Location',
    heatsStageWorkoutsDescr: 'Select and order the workouts that will occur at this location for each day of your competition.',
    stageNameDescr: 'The name of the location you are creating. Example: Pull-up Rack, Barbell Platform, Lake, Track, etc.',
    locationName: 'Location Name',
    schedulingConfig: 'Thanks for trying our Scheduler',
    schedulingSecondary: 'We are continually updating and improving how the Scheduler works, and would love to hear your feedback! The rest of this wizard will walk you through the creation of your schedule.',
    schedulingSegments: 'On this step, you will set the start and end times for each segment of your competition. We have provided some default segments for you based on the number of days your competition is running.',
    schedulingStages: 'On this step, you will create your workout locations and assign workouts to them. Think of locations as the different stations or venues workouts will be completed in. We have provided sample locations for you.',
    schedulingWorkouts: 'On this step, you will adjust the various workout parameters you have assigned to your locations. These parameters include duration, transition time, and number of lanes. We have provided some defaults to get you started.',
    schedulingConfigured: 'The initial steps for creating your heat schedule have been successfully configured!',
    schedulingFinal: 'Next, you will move on to the Scheduling tab, where you can see how your schedule(s) will be \'sliced\' into different time sections.',
    schedulePageTitle: 'Schedule',
    scheduleYours: 'Your Schedule',
    loginSchedule: 'To see your Schedule,',
    missingDataWarning: 'Your competition is not suitably configured for the scheduler to be able to run. If you want to design a schedule, you will need to resolve the following requirements and check back here:',
    noDivisionsWarning: 'No divisions are defined for this competition.',
    noWorkoutsWarning: 'No workouts are defined for this competition.',
    noStagesWarning: 'No locations are defined for this competition\'s schedule.',
    schedulingInfo: 'From this tab, you can see and manage the various segments you have created. Click the dropdown icon to get a detailed view of your segment, where you can set division order and establish global transition times',
    schedulingPanelInfo: 'Below are the different slices of your competition. Divisions can be reordered within each slice.',
    schedulePageInfo: 'No schedule has been published yet for this competition. For more information, reach out to the organizer of the event using the email below.',
    confirmPublish: 'Confirm',
    addSegment: 'Add Segment',
    segmentTitle: 'Label',
    segmentTitleDesrc: 'What is the name of this day (e.g. Day 1, Thursday, etc)?',
    loadingSegments: 'Loading Segments...',
    heatsDraft: 'Draft',
    minute: 'minute',
    minutes: 'minutes',
    second: 'second',
    seconds: 'seconds',
    seedingInfo: 'From this tab, you can modify athlete seeding.  Random seeding of your athletes has automatically been applied. Click the dropdown icon to override this seeding on an athlete by athlete case. Lower numbers indicate higher rated seeding (1 > 4).',
    manageHeatsInfo: 'From this tab, you can see and manage the heats of each schedule you have created. You can manually set a heat time by selecting the Edit Time button.',
    timeBlockLabel: 'Time Box Only',
    timeBlockDesc: 'This segment will not have any heats but rather just be a box of time on your schedule.',
    timeBlockCheckBoxText: 'Yes, flag as a time box segment.',
    expand: 'Expand',
    heatsNoJudges: 'No judges assigned yet',
    configuration: 'Configuration',
    defaultErrorMessageSavingJudgeName: 'Error Saving. Try again!',
    heatsNoHeatsSegment: 'Nothing scheduled for this segment yet',
    deleteConfirm: 'Delete',
    schedulePublishWarning: 'It will make the schedule public and allow athletes to view their personal heats.',
    scheduleUnpublishWarning: 'Unpublishing will remove the schedule from the public landing page and hide athletes\' personal heats. Are you sure?',
    heatsLastSegmentWarning: 'You must have at least one segment and this is the only one you have.',
    heatsLastLocationWarning: 'You must have at least one workout location and this is the only one you have.',
    heatsDeletePublishedLocationWarning: 'One or more of your segments using this location are on a published schedule.',
    heatsSchedulesNoWorkout: 'No workouts assigned.',
    heatsSchedulesAssignWorkout: 'Assign some.',
    heatsSchedulesInvalidWarning: 'Invalid Parameters. Could not compute schedule.',
    heatsSeedsNoAthletes: 'No athletes registered for this division',
    heatsFetchRegistrations: 'Fetching registrations...',
    heatsHeatsJudgesInvalidSchedule: 'The schedule for this segment is invalid. Please correct in order to proceed.',
    heatsSchedulesPublishedWarning: 'You cannot make any changes here because this segment\'s schedule is published.',
    heatsCreated: 'Created',
    heatsSchdulesTimeOverSegmentWarning: 'Your schedule is <strong>{timeOver} minutes</strong> past the end of your segment. You can adjust transition time between divisions, workout parameters, and/or segment end times to resolve this.',
    heatsPreviewInstructions: 'This is a preview of what will be published on your landing page.  Each <em>Segment</em> is published individually, allowing you to roll out the schedule as you are ready.',
    heatsPreviewRegOpenWarning: 'Cannot publish until registration closes',
    unpublish: 'Unpublish',
    confirmUnpublish: 'Unpublish',
    areYouSure: 'Are you sure?',
    areYouSurePublish: 'Are you sure you are ready to publish?',
    areYouSureUnpublish: 'Are you sure you are ready to unpublish?',
    unpublishWarningIntro: 'After you unpublish, certain actions can cause your schedule to be completely regenerated:',
    unpublishWarningDivisions: 'Adding or deleting divisions',
    unpublishWarningWorkouts: 'Adding or deleting workouts',
    unpublishWarningAdvancedWorkouts: 'Excluding or including workouts on divisions as part of advanced scoring policy management',
    unpublishWarningWorkoutHeats: 'Changing the workout heat parameters',
    unpublishWarningWorkoutLocations: 'Adding or deleting workout locations',
    unpublishWarningWorkoutLocationsConfig: 'Changing configuration of workout locations',
    unpublishWarningSeeding: 'Modifying athlete seeding',
    unpublishWarningBody: 'Doing any of the above after you unpublish will result in the regeneration of your schedule.  This means any judges you\'ve entered will be lost and time/locations that your athletes have already seen will likely change.',
    pleaseConfirm: 'Please confirm',
    unpublishWarningTypePublish: 'Type \'unpublish\' to confirm you really want to do this.',
    heatsPreviewInvalidWarning: 'Schedule isn\'t valid. Correct before publishing.',
    heatInvalidStartHere: 'Start here.',
    publishedScheduleWarningHeader: 'You have a published schedule',
    /// These three are all together.
    publishedScheduleWarningBody1: 'You must',
    publishedScheduleWarningBody2: 'unpublish it',
    publishedScheduleWarningBody3: 'in order to make changes.',
    /// End grouping...

    launchModalHeader: 'has been submitted for review!',
    launchModalLead1: 'Awesome! You have successfully created your competition and sent it to us for review.',
    launchModalLead2: 'Our staff will:',
    launchModalList1: 'Review your competition details',
    launchModalList2: 'Contact you about our different payment options',
    launchModalList3: 'Confirm the date you want to publish your competition',
    launchModalLead3: 'We are proud to partner with you in throwing an amazing competition!',
    launchModalButton: 'Great! Let\'s do it!',

    intentModalHeader: `Welcome to ${APP_NAME}!`,
    intentModalIntro: 'We are thrilled to get you started! Help us personalize your experience by telling us about yourself.',
    intentModalOptionSelect: 'I want to:',
    intentModalParticipant: 'I am a Participant',
    intentModalParticipantDescr1: 'Register for a competition',
    intentModalParticipantDescr2: 'View leaderboards',
    intentModalParticipantDescr3: 'Discover new competitions',
    intentModalParticipantButton: 'Start Here',
    intentModalOrganizer: 'I am an Organizer',
    intentModalOrganizerDescr1: 'Create and manage a competition',
    intentModalOrganizerDescr2: 'Add/Review Scores',
    intentModalOrganizerDescr3: 'Publish Leaderboards',
    intentModalOrganizerButton: 'Start Here',
    intentModalSpectator: 'I am a Spectator',
    intentModalSpectatorDescr1: 'Buy tickets for a competition',
    intentModalSpectatorDescr2: 'View leaderboards',
    intentModalSpectatorDescr3: 'Discover new competitions',
    intentModalSpectatorButton: 'Start Here',

    dashboardOrganizerNoComps: 'You have not created any competitions yet. <strong>Add a Competiton</strong> to get started!',
    dashboardParticipantNoComps: 'You currently aren\'t registered for any competitions. <strong>Find a Competition</strong> to get started!',
    dashboardSpectatorNoComps: 'You currently don\'t have tickets to any competitions. <strong>Find a Competition</strong> to get started!',
    scoresubModalClose: 'Close',
    athleteToggle: 'Participant',
    organizerToggle: 'Organizer',
    spectatorToggle: 'Spectator',
    findCompButton: 'Find a Competition',
    findCompHeader: 'Find a Competition',
    findCompSearchHeader: 'Search for a Competition',
    findCompSearchDescr: 'Search for a competition by name to find one you are interested in registering for',
    findCompSearchResults: 'Search Results',
    findCompResultLandingPage: 'Landing Page',
    findCompFetchLocation: 'Fetching Location...',
    findCompUseLocation: 'Use My Location',
    findCompFetchSuggestions: 'Fetching Suggestions...',
    findCompRecentlyViewed: 'Recently Viewed',
    findCompNoSuggestions: 'No suggestions found.',
    findCompFetchSearchResults: 'Fetching Search Results...',
    findCompNoSearchResults: 'We did not find any competitions matching your search terms.',
    findCompSuggestions: 'Suggestions',
    registrationCap: 'Registration Cap',
    athleteRegistrationCap: 'Enter the maximum amount of athlete registrations you want to accept for this competition. Individual division registration limits still apply, but will be superseded by the registration cap. Leave the field blank and save to remove the athlete registration cap.',
    noRegistrationCap: 'No registration cap defined.',
    totalRepsInWorkout: 'Total Rep Count',
    totalRepsInWorkoutNA: 'Total Rep Count - n/a',
    totalRepsInWorkoutDescr: 'If this workout has a time cap and involves counting the number of reps completed, enter the total rep count for the workout.',
    minimumWorkRequired: 'Minimum Work Required',
    minimumWorkNotMet: 'Minimum Work Not Met',
    minimumWorkRequiredDescr: 'If an athlete’s score doesn’t meet or exceed this value for the workout, they will be moved to the bottom of the overall leaderboard.',
    timeCap: 'Time Cap',
    timeCapDescr: 'If this workout has a time cap, enter it using hours, minutes and seconds.',

    acceptTerms: 'I accept the',
    latestTerms: 'latest terms of service',
    submitConsent: 'Accept',
    tosUpdated: 'Our Terms of Service has been updated!',

    launchPublishModal: 'Launch Your Competition!',
    readyToLaunch: 'Lets do this!',
    areYouReadyToLaunch: '<p class=\'lead\'>Launch your Competition</p><p>It\'s free for you to launch a competition. Participants pay processing fees when they register per the terms of service.</p>',

    bibNumber: 'Bib #',
    registrationAccess: 'Registration Access',
    registrationAccessHeader: 'Registration Access',
    registrationAccessCheckboxMessage: 'Allow athletes to update their registrations',
    registrationAccessDescr: 'By default, athletes are able to update their registration details at any time. This includes changing any custom field responses as well as switching their division. Unchecking this option will prevent athletes from being able to update their registration information or change their division after registering.',
    regDetailDescription: 'Description',
    regDetailQuantity: 'Quantity',
    regDetailRegistration: 'Registration',
    regDetailPurchases: 'Purchases',
    regDetailAdd: 'Add',
    regDetailDivision: 'Division',
    regDetailBib: 'Bib #',
    regDetailLeaderboardName: 'Leaderboard Name',
    regDetailTeamMember: 'Team Member #',
    regDetailEmail: 'Email',
    invitationsMenuLabel: 'Invitations',
    invitationPageHeader: 'Invitations',
    createInvitationLabel: 'Create',
    manageInvitationsLabel: 'Manage',
    createInvitationPageHeader: 'Create an Invitation',
    createInvitationPageIntro: 'Compose your message, add and rank your invitees, and save as you go.  Hit Publish when you are ready to start sending your invites.',
    invitationFormLabelMustMatch: 'Email Must Match',
    invitationFormHelpMustMatch: 'The email of the accepting user must match the email that was invited.',
    invitationFormLabelLabel: 'Invitation Label',
    invitationFormLabelDescription: 'The name of your campaign. This is a reference for your use only.',
    invitationFormLabelDivision: 'Division',
    invitationFormHelpDivision: 'The division to invite someone to.  Setting it blank allows the invitee to pick their division.',
    invitationFormHelpDivision2: 'Invites with unassigned divisions may not have a registration slot reserved for them due to sellouts.',
    invitationFormLabelExpireDays: 'Sending Mode',
    invitationFormHelpExpireDays: 'The number of days from when the email is sent to when the invitation expires. Setting it blank means invitations never expire and all emails will be sent an invitation once published.',
    invitationCampaignsHeader: 'Invitation Campaigns',
    invitationCampaignsLead: 'Create and manage your invitation campaigns.',
    invitationCampaignsHelp: 'Click on the invitation “Label” to get a detailed view on your campaign status.',
    invitationDetailHelpText: 'Your invitation has been scheduled to send and will start going out shortly.',
    invitationStopWarning: 'Pressing this button will stop this campaign from sending any more invites and end the campaign permanently.',
    invitationStopHelp: 'Stopping this invitational will prevent any more invites from being sent, but will not revoke any invites that have already been delivered. Are you sure you want to proceed?',
    invitationPublishConfirmHelp: 'Publishing your invitation campaign will make it live and start the process of sending out invites. Once you publish, you will not be able to edit your email, add more invites, or rearrange invite order. Are you sure you are ready to publish?',
    publishConfirm: 'Yes, Publish',
    reseed: 'Reseed',
    inviteOnlyCompRegistrationHelpText: 'You must receive an invite to register for this competition. Please reach out to your organizer for more information.',

    saveDraft: 'Save Draft',
    createInvitationDraft: 'Create Invitation Draft',
    compose: 'Compose',
    invite: 'Invite',
    saveInviteList: 'Save Invitees',
    inviteMessagePreviewLoading: 'Rendering Preview...',
    invitationsEmailImportLabel: 'Import Email Addresses',
    invitationsEmailImportHelpText: 'Copy and paste email addresses of those you wish to invite (either one per line or comma/space delimited)',
    manageInvites: 'Manage Invites',
    addInvites: 'Add Invites',
    inviteDetailEmail: 'Email',
    inviteDetailSent: 'Sent',
    inviteDetailExpires: 'Expires',
    inviteDetailStatus: 'Status',
    inviteStopCampaign: 'Stop Campaign',
    inviteStop: 'Stop',
    inviteConfirmStop: 'Yes, Stop',
    inviteDetailDescr: 'Invites will be sent based on priority, starting from the top of the list.  As invitations are accepted or expire, more will be sent. Once all invites have been sent or have expired, the campaign will end.',
    inviteDetailExpireDays: 'Invitations will expire <strong>{invitation_expire} day(s)</strong> from when they are sent.',
    inviteManageLabel: 'Label',
    inviteManageStatus: 'Status',
    inviteManageTotalInvites: 'Total Invites',
    inviteManageSent: 'Sent',
    inviteManageAccepted: 'Accepted',
    invitationFormLabelMessageHeader: 'Brief message (optional)',
    invitationFormLabelMessageDescr: 'We will include this message in the generated invitation email.',
    inviteStatusExpired: 'Expired',
    inviteStatusAccepted: 'Accepted',
    inviteStatusDeclined: 'Declined',
    inviteStatusBadEmail: 'Bad Email Address',
    inviteStatusPending: 'Pending',
    inviteDefaultMessage: 'We are happy to invite you to register for {message}!',
    invitationManageSecHeader: 'Drag and drop to re-order invitees. Invites will be sent based on priority from top to bottom.',
    invitePublishedTime: 'Published at',
    inviteDeleteInvitee: 'Delete',

    registrationInvites: 'Invites Required',
    registrationInviteRequiredHeader: 'Invitation Requirement',
    registrationInviteRequiredCheckboxMessage: 'Require Invites to Register',
    registrationInviteRequiredDescr: 'If selected, registration will be closed to the public and only accessible via an invitation.',
    invitationRequiredToRegister: 'Invitation Required for Registration',
    invalidInviteCodeHeader: 'Invalid Invitation Code',
    invalidInviteCodeText: 'This code has already been used or does not match the intended recipient.',
    publishWarningHeader: 'Competition is unpublished',
    publishWarningDescr: 'This feature is not available until your competition is published.',
    invitationFormNullDivWarning: 'Are you sure you don\'t want to assign a division?',
    invitationFormInviteEmailAddress: 'Email Addresses',
    invitationFormInvitePrevComps: 'From Previous Competition',
    invitationRegistrantSelectCompHeader: 'Competition',
    invitationRegistrantSelectCompDescr: 'Select the competition to invite registrants from',
    invitationRegistrantSelectDivHeader: 'Division',
    invitationRegistrantSelectDivDescr: 'Select the division to invite registrants from',
    invitationLoadDivisions: 'Loading divisions...',
    invitationLoadRegistrants: 'Loading registrations...',
    invitationRegSelectorHead: 'Registrations',
    invitationRegSelectorDescr: 'Registrations are ordered by their leaderboard placement in <strong>{source_comp}</strong>',
    invitationSelectTop: 'Select Top',
    invitationSelectTopDescr: 'Select all registrants or enter a number to select the top X athletes to be added to this campaign.',
    invitationNoRegistrants: 'There are no registrations in this division.',
    leaderboardSettingsSubHeader: 'Customize your leaderboard by adjusting the following settings.',
    leaderboardFlagEnabledMessage: 'When toggled, displays country flag of athlete. If athlete has not set their country in their profile, no flag will be displayed.',
    sponsorship: 'Advertising',
    sponsors: 'Sponsors',
    manageSponsors: 'Manage Sponsors',
    sponsorsSubHeader: 'Create sponsors, add affiliate links, and upload image assets for use in ad campaigns.',
    addSponsor: 'Add Sponsor',
    sponsorName: 'Sponsor Name',
    sponsorNameDescr: 'The official name of your sponsor.',
    sponsorLink: 'Website URL',
    sponsorLinkDescr: 'Provide a link to your sponsor. When a spectator clicks on sponsor\'s image in the ad spot, they will be sent to the provided link.',
    sponsorLogo: 'Logo',
    sponsorLogoDescr: 'Upload a logo for your sponsor that will appear in ad campaigns. We recommend a transparent image with the following dimensions: {width}x{height}. An image is required to create a sponsor.',
    sponsorDeleteDescr: 'The sponsor will be removed from any existing carousels or ad campaigns it has been assigned to.',
    adCarousels: 'Ad Carousels',
    manageAdCarousels: 'Manage Carousels',
    adCarouselsSubHeader: 'Create your ad carousels and fill them with your sponsor assets. An ad carousel is a list of sponsor logos that rotates at regular intervals.',
    addAdCarousel: 'Add Carousel',
    adCarouselMuteLogosDescr: 'Sponsor logos will be muted.',
    adCarouselName: 'Carousel Name',
    adCarouselNameDescr: 'The name of the carousel',
    adCarouselSponsorsDescr: 'Drag and drop sponsors into the Carousel Staging area below. If ordering is enabled, sponsors will be shown from top to bottom.',
    adCarouselStage: 'Carousel Stage',
    adCarouselSponsorsOrderDescr: 'Sponsors must be shown in the order specified.',
    adCarouselPreview: 'Carousel Preview',
    adCarouselDeleteDescr: 'Deleting this carousel will also delete any Ad Campaigns it is assigned to.',
    adCampaigns: 'Ad Campaigns',
    manageAdCampaigns: 'Manage Ad Campaigns',
    adCampaignsSubHeader: 'Create your ad campaigns, assign your ad carousels, select which public pages your ad carousels are displayed on, and configure the times in which they are shown.',
    addAdCampaign: 'Add Campaign',
    adCampaignName: 'Campaign Name',
    adCampaignNameDescr: 'Provide a name for the campaign',
    adCampaignCarousel: 'Carousel',
    adCampaignCarouselDescr: 'Select the carousel to use for this campaign',
    adCampaignPages: 'Pages',
    adCampaignAddAllPages: 'Add to All Available Pages',
    adCampaignPagePreview: 'Preview',
    adCampaignPagesDescr: 'Select all available pages or choose specific sections of each page',
    adCampaignDates: 'Dates',
    adCampaignDatesDescr: 'Select a date and time to start your campaign and end it. The carousel will only show on the selected pages if the current date and time are within this date range.',
    adCampaignConflictingCampaigns: 'Conflicting Campaigns',
    adCampaignConflictingCampaignsWarning: 'You can\'t save this campaign because it would conflict with the following campaigns:',
    adCampaignConflictingPagesWarning: 'These campaigns share the following page campaign sections at an overlapping time period:',
    adCampaignNoCarousels: 'There are no ad carousels available. Create one using the <a href="/app/competitions/{competitionId}/setup/marketing/ad-carousels/">Ad Carousels Page</a>.',
    adCampaignsReport: 'Ad Report',
    filter: 'Filter',
    adCampaignsFilterDescr: 'Filter by campaign, carousel, or page section',
    carousel: 'Carousel',
    pageSlots: 'Page Sections',
    selectCampaign: 'Select a campaign...',
    selectCarousel: 'Select a carousel...',
    selectPageSection: 'Select a page section...',
    ticketLinks: 'Ticket Links',
    ticketer: 'Ticketer',
    pageNotFound: 'That page could not be found.',
    pleaseCheckLinkAgain: 'Please check the link to this page again and ensure it is correct.',
    noPermission: 'You do not have permission to view this.',
    publishHeatAssignments: 'Publish Heat Assignments',
    areYouSurePublishHeatAssignments: 'Are you sure?',
    heatAssignmentPublishWarning: 'After publishing, athletes will see their assignments on their personal schedule.',
    unpublishHeatAssignments: 'Unpublish Heat Assignments',
    areYouSureUnpublishHeatAssignments: 'Are you sure?',
    unpublishHeatAssignmentsWarningIntro: 'This will remove heat assignments from public view of schedules',
    unpublishHeatAssignmentsWarningBody: '',
    confirmUnpublishHeatAssignments: 'Yes, Unpublish Heat Assignments',
    ticketing: 'Ticketing',
    spectators: 'Spectators',
    manageAssignmentsInfo: 'Expand your segments to have access to manually select the heat/lane for each athlete',
    competitionLandingDefaultDescr: '<h1><span style="color: rgb(36, 41, 46);">Welcome to {competitionName}!</span></h1><p><br></p><p><span style="color: rgb(36, 41, 46);">We are thrilled you want attend our event. Information regarding the competition date, workouts and divisions can all be found on our landing page. From here, you can also register, view leaderboards, buy tickets, and more! </span></p><p><br></p><p><span style="color: rgb(36, 41, 46);">If you have any questions, please reach out to <a href="mailto:{competitionEmail}">{competitionEmail}</a> for assistance.</span></p>',
    hashtagsPlaceholder: 'Add hashtag...',
    defaultHashtags: 'Suggested Hashtags',
    hashtags: 'Hashtags',
    hashtagsLabel: 'Custom Leaderboard League',
    organizerHashtagExplanation: 'Athletes can use hashtags to compete with smaller groups on a custom leaderboard.<br/>Type in a list of hashtags that will be suggested to your athletes at registration.',
    myHashtagsDescr: 'Create searchable hashtags to compete with your league or friends on your own custom leaderboard (#ArmyStrong, #NYC, #FitLife, etc.)',
    advancedFilters: 'Search/filter this division',
    applyFilters: 'Apply Filters',
    clearFilters: 'Clear Filters',
    birthdateLabel: 'Birthdate',
    selectMonthYearLabel: 'Select a month and year first',
    selectDayLabel: 'Select day',
    selectMonthLabel: 'Select month',
    selectYearLabel: 'Select year',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    delegates: 'Delegates',
    manageDelegates: 'Manage Delegates',
    grossRevenue: 'Gross Revenue',
    publishedCompetitions: 'Published Competitions',
    totalFees: 'Total Fees',
    noMatchingAthletes: 'There are no athletes that match the provided filters.',
    filterEntriesFound: 'athletes found on this leaderboard.',
    canFilterLeaderboardLabel: 'Use as Leaderboard Filter',
    canFilterLeaderboardDescr: 'This question can be used to filter leaderboards down to smaller groups of athletes.',
    iJustRegistered: `I just registered for {compName} at ${SHORT_DOMAIN}!`,
    shareYourRegistration: 'Download and share this image to let your friends know you registered!',
    iJustScored: `I just logged a score of {score} for {workout}. Checkout the leaderboards for {compName} at ${SHORT_DOMAIN}!`,
    shareYourScore: 'Download this image and share your score with your friends!',
    URL: 'URL',
    pasteURL: 'Paste a URL to create the link to',
    addLink: 'Add Link',

    howToFilterModalTitle: 'Did you know?',
    howToFilterModalBody: 'You can search for an athlete or create a leaderboard with just you and your friends by clicking "Search & Filter."',
    howToFilterModalButton: 'Got it!',

    howToShareModalTitle: 'Share your custom board',
    howToShareModalBody: 'Sharing this custom leaderboard is as easy as copying and pasting the web address!',
    howToShareModalButton: 'Got it!',

    timezoneNotSet: 'Timezone Not Set - Certain features will not work correctly or will otherwise have unexpected results.',

    leaderboardAutoPublishTurnedOn: 'Leaderboard auto-publishing has been turned ON. <a href="/app/competitions/{competitionId}/leaderboards/settings/">Update Settings</a>',
    leaderboardAutoPublishTurnedOff: 'Leaderboard auto-publishing has been turned OFF. <a href="/app/competitions/{competitionId}/leaderboards/settings/">Update Settings</a>',

    trials: {
      oneDayTrial: 'Try it Free Right Now!',
      yourTrialExpired: 'Your trial has expired',
      callUs: `Call Us${window.ThrowdownsConfig.CONSTANTS.salesNumber ? ` at ${ window.ThrowdownsConfig.CONSTANTS.salesNumber}` : ''}!`,
      nocc: 'No credit card required',
      activate: 'Activate!',
      weSentARequest: 'We have sent a request to your account rep to activate this feature. They will be in touch shortly!',

      sponsorship: {
        img: 'https://strongest.com/wp-content/uploads/2020/03/throwdowns-marketing-1024x525.png',
        icon: 'rectangle-ad',
        title: 'Sponsorship Kit',
        description: 'Unlock unique logo placements for your sponsors and their brands! This kit allows you to create custom sponsorship content on key pages to increase revenue and keep your sponsors happy.',
        features: [
          {
            icon: 'conveyor-belt-boxes',
            copy: 'Create rotating sponsor logos on your most viewed competition pages.',
          },

          {
            icon: 'chart-line',
            copy: 'Ensure sponsor value with customizable URLs on your logos to track page views and click-through rates.',
          },

          {
            icon: 'dollar-sign',
            copy: 'Increase revenue for your competition by drawing in new sponsors!',
          }
        ]
      },

      scheduling: {
        img: 'https://strongest.com/wp-content/uploads/2020/03/throwdowns-scheduling-1024x587.jpg',
        icon: 'stopwatch',
        title: 'Scheduling Kit',
        description: 'Heat scheduling is often a last minute “gotcha” that organizers think about way too late. With this kit, you can build and publish your schedule to let everyone know the what/where/when for each moment of your competition. Your athletes, fans, volunteers and staff will thank you.',
        features: [
          {
            icon: 'clock',
            copy: 'Create schedules that are seamlessly integrated with our Registration and Scoring systems.',
          },

          {
            icon: 'table',
            copy: 'Calculate and manage schedules within the app – No separate spreadsheets!',
          },

          {
            icon: 'users',
            copy: '“Reseed” your athletes painlessly with our purpose-built Scheduler.',
          }
        ],
      },

      liveScoring: {
        img: 'https://strongest.com/wp-content/uploads/2020/05/throwdowns-scoring-broadcasting.png',
        icon: 'table-list',
        title: 'Live Scoring Kit',
        description: 'Leverage the tools necessary to draw viewers from around the world into your competition. With this kit, you can track and display results as they happen in real-time: no waiting for the heat to finish! Empower commentators to tell AND show a great story with relevant data-driven, live action results on-screen.',
        features: [
          {
            icon: 'award',
            copy: 'Continuously update Leaderboards for each heat in real-time.'
          },
          {
            icon: 'tv',
            copy: 'Utilize data-driven graphics and post results on clock displays, mobile devices, or screen-top scoring ribbons.'
          },
          {
            icon: 'dollar-sign',
            copy: 'Maximize revenue from tickets, online viewers & sponsors.'
          }
        ]
      },

      precisionTiming: {
        img: 'https://strongest.com/wp-content/uploads/2020/05/throwdowns-precision-timing.png',
        description: 'Let your athletes finish strong with an emphatic action that not only entertains, but delivers accuracy. Our Precision Timing Kit includes the buttons, as well as state-of-the-art integration with chip timers to ensure you run a top-notch event with timing accurate to 1/100th of a second. No more human error disputes, no more guessing: just crowd-pleasing, spectacular finishes.',
        title: 'Precision Timing Kit',
        features: [
          {
            icon: 'stopwatch',
            copy: 'Ensure accuracy without the risk of human timing error.'
          },
          {
            icon: 'trophy',
            copy: 'Create exciting, highlight worthy finishes by hitting a button or crossing a finish line powered by timing chips.'
          },
          {
            icon: 'award',
            copy: 'Look professional with automated, technology-driven results tracking.'
          }
        ]
      },

      broadcasting: {
        img:'https://strongest.com/wp-content/uploads/2020/05/throwdowns-scoring-broadcasting.png',
        icon: 'tv',
        title: 'Broadcast Kit',
        description: 'Our Broadcasting Kit delivers network quality graphics that link seamlessly with data feeds from our live scoring and commentator information systems. Every passing second is precious during a live production, so we’ve optimized the software and workflows so that you can pull off the highest quality production with a fraction of the typical effort required.',
      }
    },

    siteContent: {
      topLevelHelp: '<div class="content"><h2>Welcome</h2><p><br></p><p>As you are interacting with competitions, you\'ll notice a <strong>?</strong> help icon (just like the one that\'s selected to the menu on the left) that provides targeted contextual help for how each part of the app works.</p></div>',

      compSetupMarketing: '<div class="content"><h1>Marketing</h1><p>Under the <strong>Marketing </strong>sub-tabs, you can customize nearly all the major marketing aspects of your competition.</p><ul><li>The <strong>Setup</strong> tab contains all the high level information about the competition, such as the name, web address, contact information, and cover photo.</li><li>The <strong>Content</strong> tab is where you can edit landing page content. This is the first page users will see when they come to your competition and the primary page that you\'ll want to share on social media to market your competition.</li><li>The <strong>Time &amp; Place</strong> tab is where you can set the venue location and address for live competitions. You can also set the official date and timezone of the competition from this menu.</li><li>If your competition allows athletes to submit their own scores, you\'ll be able to configure the settings for score submission under the <strong>Online Scoring </strong>tab.</li></ul><p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for more support articles on marketing your event.</p></div>',

      compSetupProgramming: '<div class="content"><h1>Programming</h1><p>Under the <strong>Programming</strong> sub-tab, you can customize every aspect of your competition\'s divisions, workouts, and scoring policies.</p><ul><li>The <strong>Divisions </strong>and <strong>Workouts </strong>tabs allow you to manage all the different settings for your divisions and workouts.<ul><li>Within each division/workout, you can add/remove entries, embed content (including images and videos), and set advanced details like registration caps per division, total number of team members, or workout release times.</li><li>We recommmend that you include clear movement standards for every workout and a short description for each division.</li></ul></li><li>The <strong>Scoring Policies </strong>tab is where you can set specific rules on how scoring is calculated.</li><ul><li>The <strong>Scoring Type</strong> affects all divisions and workouts, and determines overall athlete placement on the leaderboard. We recommend using either placement-based scoring or the standard CrossFit® Games points tables. You can learn more about these scoring types in <a href=http://help.strongest.com/en/articles/3062621-choosing-your-scoring-policies>this help article</a>.</li><li>For workouts, you\'ll either designate that a higher score value is better (e.g. AMRAP, max effort lifts, etc.) or a lower score value is better (time-based workouts.) You can set tie breaker policies, rep counts, and time caps here as well.</li></ul></ul><p>Remember: the key to great programming is simplicity. The easier it is for athletes to understand the standards and how scoring works, the better! </p><p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for more support articles on creating your competition programming or setting up your scoring policies.</p></div>',

      compSetupRegistration: '<div class="content"><h1>Registration</h1><p>Under the <strong>Registration </strong>sub-tabs, you can customize the entire registration experience for your athletes and volunteers.</p><ul><li>The <strong>Content</strong> tab is where you can customize the content that user will see when they arrive at your registration page. You can input text, as well as embed images and video.</li><li>The <strong>Fees</strong> tab is where you can specify ticket prices and the currency to be used at athlete checkout.</li><li>The <strong>Retail</strong> tab is where you can create and manage additional merchandise items to be offered at registration. You can set the name, price, and quantity of merchandise.  </li><li>The <strong>Dates</strong> tab is where you can configure the open/close dates and times for registration. Keep in mind that timezone settings apply here. You can change those under the Marketing menu as needed.</li><li>The <strong>Deposits </strong>tab shows you the Stripe account the competition is connected to. Your Stripe account is where you\'ll be receiving deposits as your athletes register.</li></ul><p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for more support articles on customizing your registration and managing your registrants </p></div>',

      compSetupAdvanced: '<div class="content"><h1>Advanced Settings</h1><p>The <strong>Advanced </strong>sub tabs contain several extra features that can be used to further customize your competition experience, especially at registration.</p><ul><li>If you\'d like to offer coupons to your athletes, you can do so under the <strong>Coupons </strong>tab. You can create coupons with a variety of constraints, such as fixed or percentage-based amounts off of the ticket price, expiration dates, limited numbers of coupons, etc.</li><li>The <strong>Custom Waiver</strong> tab allows you to create a custom waiver for registration. We\'ve provided some default waiver content, but we always recommend that you review it carefully and use your own waiver if you have one that\'s already been reviewed by your legal team.</li><li>You can add <strong>Custom Fields</strong> to your registration form if there\'s additional information you\'d like to capture from athletes. For example, some organizers like to ask athletes how they heard about the competition or ask if an athlete is a first-time competitor. This information can be later retrieved through the export feature in the <strong>Registrants </strong>tab.</li><li>It\'s highly unlikely that you\'ll need to make changes to the <strong>Advanced Scoring Policies</strong> sub-menu. If you feel that your competition has special scoring needs that the standard settings in the Programming tab didn\'t cover, please contact us, and we\'ll be glad to help you with advanced configuration.</li><li>The <strong>Registration Cap</strong> is where you can set a global cap on the number of athlete registrants allowed for your competition.</li> <li><strong>Registration Access</strong> determines whether your registants have the ability to update their registration from their dashboard. This is enabled by default. If disabled, athletes will not be able to update their registration after they pay.</li><li>Toggling <strong>Invites Required</strong> will lock registration and require that registrants have an invite in order to register. Invites are sent through the <strong>Invitations</strong> tab.</li></ul><p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for more support articles on these advanced features.</p></div>',

      compRegistrants: '<div class="content"><h1>Registrants</h1><p>The <strong>Registrants </strong>sub-tabs contain simple reports that show who has registered for your competition by division.</p><p>There are a couple of other features as well:</p><ul><li>You can view athlete names, emails, date of registration, and registration charges. </li><li>You can edit an athlete’s leaderboard name and change their division. </li><li>You can export registration data across all divisions.</li></ul><p>The <strong>Request Export</strong> prompt at the top right of the page allows you to take a “snapshot” export of all your athlete registration data. Once it is ready, the app will send you an email containing a csv file of all your registrants for easy storage and analysis.</p></div>',

      compScoring: '<div class="content"><h1>Score Entry and Review</h1><p><br></p><ul><li><span style="background-color: transparent;">The </span><strong style="background-color: transparent;">Score Entry</strong><span style="background-color: transparent;"> sub-tabs are where you\'ll manage scores for each of your divisions.</span></li><li><span style="background-color: transparent;">You can use the </span><strong style="background-color: transparent;">Data Entry Links</strong><span style="background-color: transparent;"> tab to create and share "kiosk score entry" links with individuals who you\'d like to assign as delegates. Typically, these individuals will be members of your staff who are keying in scores as paper score cards arrive to the scoring desk.</span></li><li><span style="background-color: transparent;">Under each division sub-tab, you can key in scores and preview what the leaderboard will look like when the scores are published. However, the official public leaderboards will not update until you publish the leaderboards.</span></li><li><span style="background-color: transparent;">Many competitions will prefer to have the MC do a "big reveal" at the end of the competition just before the awards ceremony, and the ability to preview a leaderboard before publishing can be helpful here.</span></li><li><span style="background-color: transparent;">Manually entered athletes entries can be removed from the scoring table by completely deleting their name. This will remove all scores entered into the entry as well. &nbsp;</span></li><li><span style="background-color: transparent;">If your competition involves online scoring, you\'ll be able to review (approve/reject) all scores that are submitted by athletes with the score review tools that are under the division level sub-menus.</span></li><li><span style="background-color: transparent;">Online score submission that have been approved will automatically update to the public leaderboard after a certain amount of time (every 5 minutes or so).</span></li></ul><p><br></p></div>',

      compDelegates: '<div class="content"><h1>Competition Delegates</h1></div>',

      compSupport: '<div class="content"><h1>Support</h1><p><br></p><p><span style="background-color: transparent;">All the menus are organized into sections: </span><strong style="background-color: transparent;">Setup</strong><span style="background-color: transparent;">, </span><strong style="background-color: transparent;">Management</strong><span style="background-color: transparent;">,</span><strong style="background-color: transparent;"> </strong><span style="background-color: transparent;">and </span><strong style="background-color: transparent;">Support</strong></p><ul><li><span style="background-color: transparent;">Each tab under the </span><strong style="background-color: transparent;">Setup </strong><span style="background-color: transparent;">section allows you modify settings that you\'ve configured during the guided step-by-step process. Once you have these settings configured properly, you likely won\'t need to go back and interact with them once your competition has been launched.</span></li><li><span style="background-color: transparent;">Each tab under the </span><strong style="background-color: transparent;">Management </strong><span style="background-color: transparent;">section involves day-to-day operations for your competition.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">For example, you\'ll likely be keeping a close watch on registrations under the </span><strong style="background-color: transparent; color: rgb(33, 35, 41);">Registrants </strong><span style="background-color: transparent; color: rgb(33, 35, 41);">tab as registrations fill up.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">For online events, you\'ll also be spending regular time under the </span><strong style="background-color: transparent; color: rgb(33, 35, 41);">Score Entry</strong><span style="background-color: transparent; color: rgb(33, 35, 41);"> tab to review scores as workout windows close.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">For live in-venue events, your scoring desk will be keying in scores under the </span><strong style="background-color: transparent; color: rgb(33, 35, 41);">Score Entry</strong><span style="background-color: transparent; color: rgb(33, 35, 41);"> tab throughout the day(s) of the competition.</span></li><li><span style="background-color: transparent;">The </span><strong style="background-color: transparent;">Support </strong><span style="background-color: transparent;">section will be where we continue to create and provide unique support features to better help run your competition!</span></li><li class="ql-indent-1"><span style="background-color: transparent;">Remember, you can always reach out to us directly through Intercom, the small black text icon in the bottom right of the screen.</span></li></ul><h2> Quickstart Video</h2><p><br></p><p>Here\'s a short ~2.5 minute video we created that gives you a quick orientation of how the system works.</p><p><br></p><iframe class="ql-video" frameborder="0" allowfullscreen="true" src="https://www.youtube.com/embed/yaTL8CPR21s?showinfo=0"></iframe><p><br></p><p><br></p></div>',

      compSetupHeatScheduling: `<div class="content"><h1>Heat Scheduling</h1><p><br><strong>Welcome to the help page for creating Heat Schedules!</strong></p><p>We know that creating a schedule from scratch can be a difficult and time consuming task. That is why we built an intuitive, easy to use tool to help you create, manage, and share your heat schedule all within the ${APP_NAME} ecosystem.</p><p>In order to start building your schedule, we ask that you first go through our setup wizard. This format makes it easier to break down and work through the different parts of making a schedule.</p><p>We highly recommend that you also check out our help center for a full guide on everything you would need to know about our scheduler. The help articles are designed to not only help you through the technical bits of creating your schedule, but to also reinforce the best practices and patterns that are used by professional competitions all over the world.</p><p>If you ever have any questions or need assistance in setting up your schedule please don't hesitate to reach out to us!</p></div>`,

      compInvitations: '<div class="content"><h1>Invitations</h1><p><strong>Welcome to the help page for Invitations!</strong></p>Through the Invitations tab, you can email invitations to your athletes, volunteers, and spectators so they can register for your event.<p><p>Some of the features include:</p><ul><li>Ability to adjust the messaging in your invitation</li><li>Dynamic invite system that sends invites in the specific order you set</li><li>Functionality for inviting users to specific divisions.</li><li>Tracking metrics so you know whether an invite has been accepted, expired, or if the email address provided is invalid.</li></ul><p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for specific support articles regarding Invitations.</div>',

      compLeaderboards: '<div class="content"><h1>Leaderboard Display Preferences</h1><p><strong>Welcome to the help page for Leaderboard Display Preferences!</strong></p>This feature allows you to configure the various display settings you want for your leaderboards.<p><p>Some of the current and upcoming display preferences for leaderboards are:</p><ul><li>Ability to display the country flags of registrants</li><li>(Coming Soon!) Ability to display the affiliate names of registrants</li><li>(Coming Soon!) Ability to toggle score submission video links to appear on the leaderboard</li><li>And more!</li></ul><p>As we continue to build out configuration settings, they will appear here.</p><p>If you are trying to preview or publish your leaderboards, you would do that from the <strong>Score Entry</strong> tab, not from this tab.<p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for support articles that provide examples of our different leaderboard display options.</div>',

      compSetupTicketing: '<div class="content"><h1>Ticketing</h1><p><strong>Welcome to the help page for creating tickets for your event!</strong></p>This feature allows you to create, edit, and manage the different tickets that you will offer to your spectators.<p><p>There are 3 main sub-tabs:</p><ul><li>The <strong>Content</strong> tab allows you to customize the text that will appear at the top of the ticket purchasing page.</li><li>The <strong>Dates</strong> tab is where you will set the start date for when tickets go on-sale, and the end date for when tickets are no longer available for purchase.</li><li>The <strong>Tickets</strong> tab is where you create, edit, and delete your ticket options. Within this tab, you can configure the price, quantity, name, and description of your various tickets.</li></ul><p>Each ticket that is sold comes with a unique QR code that is sent to the purchaser both in-app and through email. This QR code makes it easy for you to validate tickets for entry during your live event.</p><p>As your tickets are purchased, your spectators and their tickets will be populated in the top-level <strong>Spectators</strong> tab. </p><p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for specific support articles regarding tickets.</p></div>',

      compSpectators: '<div class="content"><h1>Spectators</h1><p><strong>Welcome to the help page for managing your spectators!</strong></p>The <strong>Spectators</strong> sub-tab contains a simple report on the various tickets that have been purchased for your event. <p><p>From this tab, you can:</p><ul><li>View basic contact information of ticket holders, such as name and email.</li><li>View the type of ticket purchased, its unique id, as well as it\'s current redemption status.</li><li>Filter results by name, email, or ticket id. </li></ul><p>Each ticket that is sold comes with a unique QR code that is sent to the purchaser both in-app and through email. This QR code makes it easy for you to validate tickets for entry during your live event. </p><p>Check out our <a href="http://help.strongest.com/en/">Help Center</a> for specific support articles regarding spectator tickets.</p></div>',
    },


    // START PATCH WORK
    setADateRange: 'Set a Date Range',
    clearDateRange: 'Clear Date Range',
    selectAll: 'Select All',
    selectNone: 'Select None',
    close: 'Close',
    issueLoadingPaymentForm: 'There was an issue loading the payment form.  Please refresh.',
    uploading: 'Uploading...',
    imageTooBig: 'That image is too big. Limit is 5MB.',
    uploadImage: 'Upload an image',
    clearImage: 'Clear image',
    youtubeEmbed: 'YouTube Embed',
    addVideo: 'Add Video',
    loadingCompetition: 'Loading Competition',
    draft: 'Draft',
    readyToPublish: 'Are you ready to publish your competition?',
    yesPublish: 'Yes, Publish!',
    pleaseEnterAValidEmail: 'Please enter a valid email address.',
    competition: 'Competition',
    id: 'ID',
    youllBeNotifiedWhenYourExportIsReady: 'You\'ll be notified shortly via email when your export is ready.',
    deleted: 'Deleted',
    noVideo: 'No Video',
    url: 'URL', // just in case
    youtubeUrlDesc: 'The URL of the YouTube video',
    image: 'Image',
    scoreRejection: 'Score Rejection',
    scoreRejectionDesc: 'You are rejecting a score submitted by an athlete. This will hide the score on the leaderboard, as if no score was submitted.',
    rejectReason: 'Reject Reason',
    rejectReasonDesc: 'Please leave a comment explaining why the score was rejected. This will help the athlete understand why their score submission was rejected',
    rejectAndEmailAthlete: 'Reject and Email Athlete',
    unreject: 'Unreject',
    reject: 'Reject',
    unverify: 'Unverify',
    verify: 'Verify',
    evidence: 'Evidence',
    noEvidence: 'No evidence',
    showingTopOneHundredAthletes: 'Showing the top 100 athletes.  Use search to find any athlete in order to enter/modify their scores.',
    nameOrBibNumber: 'Name or Bib Number',
    spectatorFilterDesc: 'Filter on name, email, or ticket id',
    acceptRegistrationWaiver: 'Accept Registration Waiver',
    appWaiver: `${APP_NAME} Waiver`,
    compWaiver: 'Competition Waiver',
    yesIAgree: 'Yes, I agree',
    yesIAgreeToBoth: 'Yes, I agree to both',
    searching: 'Searching...',
    stoppedAt: 'Stopped at',
    seeMore: 'See More',
    groupLeaderboards: 'Group Leaderboards',
    groupLeaderboardsDesc: 'Create combined leaderboards by aggregating athletes in specific divisions.',
    divisionsMustHaveSameWorkouts: 'The selected divisions must have the same workouts',
    showCountryFlag: 'Show Country Flag',
    enableAutoPublish: 'Enable Auto Publish',
    autopublishDesc: 'When enabled, your leaderboard will automatically be published if there are any changes, at least every 10 minutes.',
    showVideoOrImage: 'Show Video/Image Links',
    showVideoOrImageDesc: 'When toggled, video/image links are displayed on the leaderboard for all scores that have a video or image submission. Otherwise, videos or images are only viewable by organizer staff in the scoring table.',
    discountedSubtotal: 'Discounted Subtotal',
    teamMembersCantShareEmails: 'Team members can\'t share email addresses as each member will need to login and sign a waiver.',
    needsToSignWaiver: 'Needs to Sign Waiver',
    time: 'Time',
    unpublishing: 'Unpublishing...',
    noScore: 'No Score',
    typeAthleteAutosuggest: 'Type athlete name for auto-complete selection to access their scoring cards.',
    capIsGreaterThanDivisionCaps: 'Although this cap is valid, its value is greater than the sum of all division caps and so it will never have any visible effect.',
    schedulePreview: 'Schedule Preview',
    thisRegeneratesAllHeatsWarning: 'This will completely regenerate heats for this selection losing any manual edits you have made.  Are you sure?',
    yesRegenerateAllHeats: 'Yes, Regenerate Heats',
    regenerateAllHeats: 'Regenerate Heats',
    generateHeats: 'Generate Heats',
    filterDivisionsDesc: 'Select a division to filter by',
    allDivisions: 'All Divisions',
    filterWorkoutsDesc: 'Select a workout to filter by',
    allWorkouts: 'All Workouts',
    editHeat: 'Edit Heat',
    heatTitleDesc: 'Title of the heat for schedule display',
    startTime: 'Start Time',
    pickAStartTime: 'Pick a start time',
    endTime: 'End Time',
    pickAnEndTime: 'Pick an end time',
    moving: 'Moving...',
    moveHeats: 'Move 1 heat here | Move {n} Heats Here',
    doneEditing: 'Done Editing',
    recalculateAssignments: 'Recalculate Assignments',
    updateFromLeaderboard: 'Update from Leaderboard',
    noScoresPublished: 'No Scores Published',
    regenerateHeats: 'Regenerate Heats',
    regenerateHeatsAreYouSure: 'This will regenerate all heats in this event. Are you sure?',
    updateManually: 'Update Manually',
    seeding: 'Seeding',
    reset: 'Reset',
    saved: 'Saved',
    clear: 'Clear',
    addJudge: 'Add Judge',
    emptyLane: 'Empty Lane',
    swapping: 'Swapping...',
    cancelSwap: 'Cancel Swap',
    swap: 'Swap',
    addBack: 'Add Back',
    addingBack: 'Adding Back...',
    removing: 'Removing...',
    yesRemove: 'Yes, Remove',
    remove: 'Remove',
    hasMultipleRegistrations: 'has multiple registrations',
    working: 'Working...',
    yesClearTodaysSchedule: 'Yes, clear today\'s schedule',
    youMustHaveAtLeastOneWorkoutLocation: 'You must have at least one workout location.',
    youMustHaveAtLeastOneDay: 'You must have at least one day.',
    addDay: 'Add Day',
    locationSchedule: 'Location Schedule',
    viewScheduleByLocation: 'View by Location',
    viewScheduleByDay: 'View by Day',
    hideContent: 'Hide Content',
    showContent: 'Show Content',
    deleteEvent: 'Delete Event',
    areYouSureYouWantToDeleteThisEvent: 'Are you sure that you want to delete this event?',
    editEvent: 'Edit Event',
    moveToDifferentDay: 'Move to a different Day',
    day: 'Day',
    moveToDifferentLocation: 'Move to a different Location',
    move: 'Move',
    customize: 'Customize',
    filterEvents: 'Filter list by workout or division',
    scheduleStartTimeDesc: 'When should the first event begin',
    addToSchedule: 'Add to Schedule',
    timeBlockTitleDesc: 'Title of the time block for schedule display',
    selectAWorkout: 'Select a Workout',
    heatScheduleWorkoutDesc: 'Pick a workout that you want to schedule heats for',
    selectADivision: 'Select a Division',
    heatScheduleDivisionDesc: 'Pick a division that you want to schedule heats for',
    eventsToSchedule: 'Events to Schedule',
    eventsToScheduleDesc: 'Select one or more events that you would like to schedule heats for',
    events: 'Events',
    timeBlock: 'Time Block',
    currentConfiguration: 'Current Configuration',
    scheduleWorkoutTitleDesc: 'The title of the workout location that will be displayed on the schedule',
    scheduleWorkoutDescriptionDesc: 'Rich text content that will be displayed on the schedule for this workout location',
    editTimeBlock: 'Edit Time Block',
    pointsTablePreview: 'Points Table Preview',
    excludeWorkout: 'Want to exclude this workout from this division\'s leaderboard?',
    confirmExcludeWorkout: 'This action will remove the workout from this division, as well as it\'s scoring policy. This workout will not appear at athlete score submission, nor on the leaderboard for this division.',
    applyToAllDivisions: 'Want to apply these settings to all divisions for this workout?',
    confirmApplyToAllDivisions: 'This action will apply the currently saved workout scoring policies to ALL divisions. Any existing scoring policies for this workout will be overwritten. This will not affect excluded workouts.',
    areYouSureYouWantToProceed: 'Are you sure you want to proceed?',
    yesApplyToAll: 'Yes, Apply to All',
    scoringWindow: 'Scoring Window',
    teamScoringLabel: 'Team Scoring',
    teamScoringDescription: 'Should team captains collect and input scores for each member of the team?',
    teamCaptainCollectsLabel: 'Team captain should collect and enter individual scores.',
    sumAggregationLabel: 'The total SUM of all team member scores',
    maxAggregationLabel: 'The HIGHEST of all team member scores',
    minAggregationLabel: 'The LOWEST of all team member scores',
    avgAggregationLabel: 'The AVERAGE of all team member scores',
    scoringAggregationLabel: 'Team scores should be based on:',
    scoringAggregationDescription: 'How should individual scores be combined for a team score?',
    yesExclude: 'Yes, Exclude',
    basicSetup: 'Basic Setup',
    brandIdentity: 'Brand Identity',
    pleaseLimitSenderName: 'Please limit name to less than 50 characters and is not an email address or contains commas.',
    pleaseEnterAValidUrl: 'Please enter a valid url.',
    theme: 'Theme',
    themeDesc: 'Pick a theme to change the style of your landing pages. You can further customize a theme by selecting colors that match your brand.',
    currentTheme: 'Current Theme',
    themeOptions: 'Theme Options',
    customizeTheme: 'Customize Theme',
    customizeThemeDesc: 'Select colors to override the {name} theme for this competition.',
    primaryBrand: 'Primary Brand',
    primaryText: 'Primary Text',
    primaryBackground: 'Primary Background',
    secondaryText: 'Secondary Text',
    secondaryBackground: 'Secondary Background',
    buttonBackground: 'Button Background',
    buttonText: 'Button Text',
    secondaryButtonBackground: 'Secondary Button Background',
    secondaryButtonText: 'Secondary Button Text',
    pageBackground: 'Page Background',
    thisWorkoutIsCurrentlyExcludedFrom: 'This workout is currently excluded from {title}. Click <strong>Include</strong> to add it back.',
    include: 'Include',
    activeCompetitions: 'Active Competitions',
    eventDate: 'Event Date',
    createdDate: 'Created Date',
    owner: 'Owner',
    searchForACompetition: 'Search for a competition',
    visitLandingPage: 'Visit Landing Page',
    orgFee: 'Org. Fee',
    athFee: 'Ath. Fee',
    athPays: 'Ath. Pays',
    taxes: 'Taxes',
    scoringLinks: 'Scoring Links',
    logs: 'Logs',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    data: 'Data',
    leaderboard: 'Leaderboard',
    ties: 'Ties',
    athleteSubmitsScore: 'Athlete Submits Score',
    platformFee: 'Platform Fee',
    platformFeeDesc: 'The platform fee is a fixed amount in competition currency plus a % of transaction',
    currencyDesc: 'The currency for the entire competition including the flat fee.',
    platformFeeFlatDesc: 'The fee in whole integer for {currency}. For decimal based currencies such as USD it will most of the time based multiplied by 100 (e.g. $5 should be entered as 500)',
    downloadScoringTemplate: 'Download Scoring Template',
    publishCompetition: 'Publish Competition',
    unpublishCompetition: 'Unpublish Competition',
    disableScheduling: 'Disable Scheduling',
    enableScheduling: 'Enable Scheduling',
    disableSponsorship: 'Disable Sponsorship',
    enableSponsorship: 'Enable Sponsorship',
    disableDevKit: 'Disable Dev Kit',
    enableDevKit: 'Enable Dev Kit',
    disableRefunds: 'Disable Refunds',
    enableRefunds: 'Enable Refunds',
    makeRegularComptition: 'Make Regular Competition',
    makeATestCompetition: 'Make a Test Competition',
    enterEmail: 'Enter Email',
    getActivationLink: 'Get Activation Link',
    processing: 'Processing...',
    rejected: 'Rejected',
    refunded: 'Refunded',
    reverse: 'Reverse',
    refund: 'Refund',
    testError: 'Test Error',
    testRejection: 'Test Rejection',
    staffDashboard: 'Staff Dashboard',
    newUsers: 'New Users',
    createdCompetitions: 'Created Competitions',
    refundRequests: 'Refund Requests',
    emailActivationLinks: 'Email Activation Links',
    youDoNotHavePermission: 'It doesn\'t look like you are authorized to access this.',
    ticketsNameDesc: 'Name of person who should receive the tickets.',
    ticketsEmailDesc: 'Email of person who should receive the tickets.',
    details: 'Details',
    yourRevenue: 'Your Revenue',
    collectedFees: 'Collected Fees',
    transactions: 'Transactions',
    nevermind: 'Nevermind',
    yesCancel: 'Yes, Cancel',
    notEnoughFunds: 'Top up Stripe account to refund',
    all: 'All',
    orLess: 'or Less',
    enterRefundAmount: 'Enter an amount to refund.',
    refundHigherThanRevenue: 'This is more than than the original transaction by',
    tooMuch: 'Too Much',
    deleteRegistrationAndPurchases: 'Delete registration and/or purchases.',
    whatDivisionsWillYouBeFeaturing: 'What divisions will you be featuring?',
    whatDivisionsWillYouBeFeaturingDesc: 'We\'ve added a few examples to get you started. You may drag &amp; drop each division to reorder its position in the list.',
    purchasesDisabled: 'Purchases Disabled',
    purchasesDisabledDesc: 'Currently, purchases are disabled. Please try again later.',
    addARegistration: 'Register for Additional Division',
    mustBeLoggedInForFeature: 'You must be logged in for this feature.',
    scheduleHasntBeenPublished: 'A schedule hasn\'t been published yet.',
    heats: 'Heats',
    mySchedule: 'My Schedule',
    stripeDashboard: 'Stripe Dashboard',
    chargesAreDisabled: 'Charges are currently disabled until the issue with your Stripe Account is resolved.',
    areYouSureYouWantToDeleteThat: 'Are you sure you want to delete <strong>{that}</strong>?',
    custom: 'Custom',
    editDay: 'Edit Day',
    dayTitleDesc: 'The title of your day that will be displayed on the schedule',
    dayDescriptionDesc: 'Rich text content that will be displayed on the schedule for this day',
    whatDayIsThis: 'What day is this?',
    editWorkoutLocation: 'Edit Workout Location',
    addWorkoutLocation: 'Add Workout Location',
    pasteYourYouTubeUrl: 'Paste your YouTube URL',
    country: 'Country',
    searchForAnAthlete: 'Search for an athlete.',
    member: 'Member',
    changeDivision: 'Change Division',
    leaderboardPolicy: 'Leaderboard Policy',
    leaderboardPolicyDesc: 'Select the scoring policy that will be used to rank scores for this division\'s leaderboard.',
    customPoints: 'Custom Points',
    customPointsDesc: 'Comma delimited points, in order of placement, for your custom points table.',
    leaderboardTiePolicy: 'Leaderboard Tie Policy',
    leaderboardTiePolicyDesc: 'Select the policy that will be used to break ties in this leaderboard\'s overall rank.',
  },

  dateTimeFormats: {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: true
    }
  },

  numberFormats: {
    currency: {
      style: 'currency', currency: 'USD'
    }
  }
};
